import React from "react";
import "./StartOptions.css";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

const StartOptions = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* ---------------- SEO Optimisation ---------------- */}
      <Helmet>
        <title>Start | List Your House or Find a Rental Home | ApkaGhr</title>

        <meta
          name="description"
          content="Start renting or listing your property on ApkaGhr. List your rental house or find affordable homes with owner details instantly."
        />

        <meta
          name="keywords"
          content="rent house, list rental home, Assam house rent, Guwahati rental rooms, apartments for rent, house owners platform India, ApkaGhr"
        />

        <meta name="robots" content="index, follow" />
        <meta name="language" content="en" />
        <meta name="theme-color" content="#7700ff" />
        <link rel="canonical" href="https://apkaghr.com/start" />

        {/* OpenGraph for Facebook / WhatsApp share */}
        <meta property="og:title" content="Start — List Your House or Find a Home | ApkaGhr" />
        <meta
          property="og:description"
          content="Easily list your house for rent or find verified rental properties. Fast, simple, and trusted platform."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://apkaghr.com/start" />
        <meta
          property="og:image"
          content="https://apkaghr.com/assets/preview-start.png"
        />

        {/* Twitter Card Preview */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Find or List a Home | ApkaGhr" />
        <meta
          name="twitter:description"
          content="Start listing your home or explore thousands of rental properties."
        />
        <meta
          name="twitter:image"
          content="https://apkaghr.com/assets/preview-start.png"
        />

        {/* Structured Data Schema - improves SEO ranking */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Start | ApkaGhr",
            url: "https://apkaghr.com/start",
            description:
              "Start renting or listing your property on ApkaGhr.",
            inLanguage: "en",
            publisher: {
              "@type": "Organization",
              name: "ApkaGhr",
              url: "https://apkaghr.com",
              logo: "https://apkaghr.com/logo.png",
            },
          })}
        </script>
      </Helmet>

      {/* ---------------- UI Content ---------------- */}
      <div className="start-container">
        <button className="start-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <h1 className="start-title">
          Start Earning or <br /> Finding a Home
        </h1>

        <div className="start-columns">
          {/* List Your House Card */}
          <div className="start-box">
            <h2 className="card-header red">List Your House</h2>
            <div className="start-step">
              <img
                loading="lazy"
                src="https://cdn-icons-png.flaticon.com/512/709/709496.png"
                alt="Upload house to get started"
              />
              <p>Make a Small Payment</p>
            </div>

            <div className="start-step">
              <img
                loading="lazy"
                src="https://cdn-icons-png.flaticon.com/512/929/929426.png"
                alt="Upload rental photos"
              />
              <p>Upload House Images</p>
            </div>

            <div className="start-step">
              <img
                loading="lazy"
                src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
                alt="House listing live"
              />
              <p>Get Listed Instantly</p>
            </div>
          </div>

          {/* Find a House Card */}
          <div className="start-box">
            <h2 className="card-header blue">Find a House</h2>
            <div className="start-step">
              <img
                loading="lazy"
                src="https://cdn-icons-png.flaticon.com/512/622/622669.png"
                alt="Browse homes near you"
              />
              <p>Browse Houses</p>
            </div>

            <div className="start-step">
              <img
                loading="lazy"
                src="https://cdn-icons-png.flaticon.com/512/455/455705.png"
                alt="Contact house owners"
              />
              <p>Connect with the Owner</p>
            </div>

            <div className="start-step">
              <img
                loading="lazy"
                src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                alt="Visit home and confirm"
              />
              <p>Notify the Owner</p>
            </div>
          </div>
        </div>

        {/* How it Works Section */}
 {/* How It Works Section */}
<div className="how-it-works">
  <h2 className="how-title">How It Works</h2>
  <p className="how-subtitle">Simple, transparent & built for everyone</p>

  <div className="how-grid">
    {/* Owners */}
    <div className="how-card">
      <h3 className="how-card-title">🏠 For House Owners</h3>
      <ul className="how-list">
        <li>
          <strong>💵 Choose a Listing Plan</strong>
          <p>Pick a small package to get started — no hidden charges.</p>
        </li>
        <li>
          <strong>🖼 Upload Photos</strong>
          <p>Add clear photos & details to attract serious tenants.</p>
        </li>
        <li>
          <strong>⚡ Go Live Instantly</strong>
          <p>Your property becomes visible to thousands instantly.</p>
        </li>
      </ul>
    </div>

    {/* Seekers */}
    <div className="how-card">
      <h3 className="how-card-title">🔍 For Home Seekers</h3>
      <ul className="how-list">
        <li>
          <strong>🔎 Explore & Filter</strong>
          <p>Find homes based on budget, room type, and location.</p>
        </li>
        <li>
          <strong>📞 Contact Owner Directly</strong>
          <p>Reach out instantly—no broker, no middleman.</p>
        </li>
        <li>
          <strong>🏡 Visit & Book</strong>
          <p>Schedule a visit & lock your favorite home in minutes.</p>
        </li>
      </ul>
    </div>
  </div>
</div>

      </div>
    </>
  );
};

export default StartOptions;
